/**
 * SaaSBOXX entitlement gate — the browser side.
 *
 * When a lab's LabBOXX subscription is suspended in SaaSBOXX, the backend
 * (shared/middleware/tenant_middleware.py) answers EVERY request for that
 * tenant with HTTP 402 `{"error": "subscription_inactive", "detail": "..."}`.
 * Every other call would fail the same way, so the session ends and the login
 * page says why, instead of a screen of broken widgets.
 */

export const SUBSCRIPTION_INACTIVE = 'subscription_inactive';

/** True when `response` is the entitlement gate's refusal. Reads a clone, so
 *  the caller can still consume the body. */
export async function isSubscriptionInactive(response: Response): Promise<boolean> {
  if (response.status !== 402) return false;
  try {
    const body = await response.clone().json();
    return body?.error === SUBSCRIPTION_INACTIVE;
  } catch {
    return false;
  }
}

/** Drop the local session and land on the login page with the reason. */
export function endSuspendedSession(): void {
  localStorage.removeItem('jwt_access_token');
  localStorage.removeItem('jwt_refresh_token');
  localStorage.removeItem('jwt_user');
  localStorage.removeItem('jwt_token_expiry');
  localStorage.removeItem('user');
  try {
    sessionStorage.removeItem('auth_state_cache');
  } catch {
    /* storage unavailable — nothing cached to clear */
  }
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = `/login?message=${SUBSCRIPTION_INACTIVE}`;
  }
}
